var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.seen)?_c('div',{staticClass:"view-file pdf",on:{"click":_vm.close_box,"contextmenu":_vm.notallowed}},[_c('div',{staticClass:"img"},[_c('iframe',{attrs:{"src":_vm.path,"width":"100%","height":"100%"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }